<div class=" pt-[80px] px-[16px] max-mobile:pt-[24px]">
    <Tag></Tag>
    <InputLink></InputLink>
</div>

<script lang="ts">
    import Tag from './Tag.svelte';
    import InputLink from './InputLink.svelte';
</script>
